export default __webpack_public_path__ + "static/media/B4_32.80240606.mp3";